import { NotificationContext } from "contexts/notification.context";
import React, { useContext, useEffect, useState } from "react";

export const Announcer = () => {
  const { notification } = useContext(NotificationContext);
  const [announcement, setAnnouncement] = useState("");

  useEffect(() => {
    const nextAnnouncement = notification?.announcement
      || (typeof notification?.content === "string" ? notification.content : "");

    // Clear old text first to force screen reader announcement
    setAnnouncement("");
    // Slight delay to ensure DOM updates
    const timeout = setTimeout(() => {
      setAnnouncement(nextAnnouncement);
    }, 100);

    return () => {
      clearTimeout(timeout);
    }
  }, [notification?.id, notification?.announcement, notification?.content]);

  return (
    <div
      id="announcement"
      role="status"
      aria-live="polite"
      aria-atomic="true"
      style={{
        position: "absolute",
        width: "1px",
        height: "1px",
        margin: "-1px",
        padding: 0,
        border: 0,
        overflow: "hidden",
        clip: "rect(0 0 0 0)"
      }}
    >
      {announcement}
    </div>
  );
};
